import { Link } from "react-router-dom";
import Input from "../../../components/input/input";
import Label from "../../../components/label/label";
import { formatIban, cleanIban } from "../../../utils/formatIban";

function ObBank({ onNext, onBack, formData, onUpdateData }) {
    
    const handleNextClick = () => {
        const cleanedData = {
            ...formData,
            iban: cleanIban(formData.iban || '')
        };
        onNext(cleanedData);
    };

    const handleBackClick = (e) => {
        e.preventDefault();
        onBack();
    };

    const handleInputChange = (e) => {
        let { name, value } = e.target;

        if (name === 'iban') {
            value = formatIban(value);
        }

        onUpdateData({ [name]: value });
    };

    return (
        <div>
            <h2>Jetzt einmal die Bankverbindung, auf die die Beträge überwiesen werden sollen.</h2>
            
            <Label labelFor="bank" labelValue="Bankinstitut: " /><br/>
            <Input
                inputType="text"
                inputName="bank"
                inputId="bank"
                inputValue={formData.bank || ''}
                onChange={handleInputChange}
                borderColor="black"
            /><br />

            <Label labelFor="iban" labelValue="IBAN: " /><br/>
            <Input
                inputType="text"
                inputName="iban"
                inputId="iban"
                inputValue={formData.iban || ''} 
                onChange={handleInputChange}
                borderColor="black"
                placeholder="DE00 0000 0000 0000 0000 00"
                maxLength={27}
            /><br />

            <Label labelFor="bic" labelValue="BIC: " /><br/>
            <Input
                inputType="text"
                inputName="bic"
                inputId="bic"
                inputValue={formData.bic || ''}
                onChange={(e) => onUpdateData({ bic: e.target.value.toUpperCase() })}
                borderColor="black"
            />

            <div className="linkContainer">
                <Link to="#" onClick={handleBackClick}>Zurück</Link>
                <Link to="#" onClick={handleNextClick}>Weiter</Link>
            </div>
        </div>
    );
}

export default ObBank;